import React, { useState } from "react";
import axios from "axios";
import "./HomeComponent.scss";
import { useNavigate } from "react-router-dom";

export const HomeComponent = () => {
  const navigate = useNavigate();

  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [dataEmpresa, setDataEmpresa] = useState(localStorage.getItem("dataEmpresa"))

  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [empresa, setEmpresa] = useState("");
  const [senhaAdmin, setSenhaAdmin] = useState("");

  const loginFunction = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      const response = await axios.post(`https://financeiro.api.protmar.com.br/verify-password`, {
        login,
        senha,
      });

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        const empresa = response.headers['dataempresa-header'];
        localStorage.setItem("dataEmpresa", empresa);

        navigate("/resumogeral");
      } else {
        setErro("Senha incorreta");
      }
    } catch (error) {
      setErro("Erro no login. Tente novamente.");
      console.error("Erro ao fazer login:", error);
    }
  };

  const handleRegister = async () => {
    try {
      const response = await axios.post("https://financeiro.api.protmar.com.br/registrousuarios/" + senhaAdmin, {
        empresa,
        login,
        senha,
      });
      if (response.status === 201) {
        alert("Registro realizado com sucesso!");
        setShowRegisterModal(false); // Fecha o modal após o registro
      }
    } catch (error) {
      console.error("Erro ao registrar:", error);
      setErro("Erro no registro. Tente novamente.");
    }
  };

  return (
    <main id="HCMain">
      <form onSubmit={loginFunction}>
        <div className="mb-3">
          <label className="form-label">Usuário</label>
          <input
            onChange={(e) => setLogin(e.target.value)}
            type="text"
            className="form-control"
            id="login"
            aria-describedby="loginHelp"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Senha</label>
          <input
            onChange={(e) => setSenha(e.target.value)}
            type="password"
            className="form-control"
            id="senha"
          />
        </div>

        <div className="d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            Entrar
          </button>
          <button type="button" onClick={() => setShowRegisterModal(true)} className="btn btn-secondary">
            Registrar-se
          </button>
        </div>

        {erro && (
          <div className="alert alert-danger mt-3">{erro}</div>
        )}
      </form>

      {/* Modal de Registro */}
      {showRegisterModal && (
        <div className="modal fade show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Registrar-se</h5>
                <button type="button" className="btn-close" onClick={() => setShowRegisterModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Empresa</label>
                  <input
                    onChange={(e) => setEmpresa(e.target.value)}
                    type="text"
                    className="form-control"
                    id="empresa"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Login</label>
                  <input
                    onChange={(e) => setLogin(e.target.value)}
                    type="text"
                    className="form-control"
                    id="loginRegister"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Senha</label>
                  <input
                    onChange={(e) => setSenha(e.target.value)}
                    type="password"
                    className="form-control"
                    id="senhaRegister"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Senha Admin</label>
                  <input
                    onChange={(e) => setSenhaAdmin(e.target.value)}
                    type="password"
                    className="form-control"
                    id="senhaAdmin"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowRegisterModal(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleRegister}>
                  Registrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};
